module.exports = __webpack_public_path__ + "static/media/7.10.086b8fb6.png";